<script setup>
import misc404 from '@/assets/images/pages/404.png'
import miscMaskDark from '@/assets/images/pages/misc-mask-dark.png'
import miscMaskLight from '@/assets/images/pages/misc-mask-light.png'
import topImage from '@/assets/images/pages/home_masthead.jpg'

// import reservedImage from '@/assets/images/pages/AdobeStock_58798975.jpeg'
// import chicagoImage from '@/assets/images/cities/chicago.jpg'
// import nycImage from '@/assets/images/cities/nyc.jpg'
// import miamiImage from '@/assets/images/cities/miami.jpg'

import logo from '@/assets/logo-400.png'
import logoLargeLight from '@/assets/logo-large-light.svg'
import {useGenerateImageVariant} from '@core/composable/useGenerateImageVariant'

const authThemeMask = useGenerateImageVariant(miscMaskLight, miscMaskDark)
</script>

<template>
  <div>
    <section class="alternate-masthead">
      <div class="home-masthead-bkg-holder">
        <img
          class="home-masthead-bkg"
          :src="topImage"
        >
      </div>
      <div class="content-wrapper">
        <div class="masthead-content">
          <img
            class="masthead-content-logo"
            :src="logoLargeLight"
          >
          <h2 class="masthead-content-headline">
            Terms of Service
          </h2>
        </div>
      </div>
    </section>
    <section class="site-section site-section--lighter">
      <div class="content-wrapper">
        <div class="">
          <p class="c0">
            <span class="c2" />
          </p>
          <h3 class="c1">
            <span class="c2">Use</span>
          </h3>
          <p class="c1">
            <span class="c3">You are allowed to use RM for both personal and commercial uses. You are responsible for the activity that happens on or actions taken through your RM Account.</span>
          </p>
          <p class="c0">
            <span class="c2" />
          </p>
          <h3 class="c1">
            <span class="c2">Password</span>
          </h3>
          <p class="c1">
            <span
              class="c3"
            >It&#39;s your responsibility to use a secure password and keep it secure.</span>
          </p>
          <p class="c0">
            <span class="c2" />
          </p>
          <h3 class="c1">
            <span class="c2">Your Conduct</span>
          </h3>
          <p class="c1">
            <span class="c3">Don&rsquo;t misuse RM. You are not permitted to use RM in a manner that would cause any applicable law(s) to be broken.</span>
          </p>
          <p class="c0">
            <span class="c2" />
          </p>
          <h3 class="c1">
            <span class="c2">Use When Not Signed In</span>
          </h3>
          <p class="c1">
            <span>RM</span><span class="c3">&nbsp;allows you to use certain parts of the app without signing in, with the intention of providing new/potential members with an easy way to get to know the app. RM takes no responsibility and assumes no liability for any use/misuse of the app in this state.</span>
          </p>
          <p class="c0">
            <span class="c2" />
          </p>
          <h3 class="c1">
            <span class="c2">Sharing</span>
          </h3>
          <p class="c1">
            <span>RM</span><span class="c3">&nbsp;allows you to share access to your account. You are responsible for any changes made to your account by individuals you have granted access.</span>
          </p>
          <p class="c0">
            <span class="c2" />
          </p>
          <h3 class="c1">
            <span class="c2">Changes to RM</span>
          </h3>
          <p class="c1">
            <span class="c3">We reserve the right to change the app. This includes adding and removing features. We will attempt to give advance notice via email if we feel a change in the app will have an impact on the public display of your content.</span>
          </p>
          <p class="c0">
            <span class="c2" />
          </p>
          <h3 class="c1">
            <span class="c2">Canceling a Paid Subscription</span>
          </h3>
          <p class="c1">
            <span class="c3">We will grant you a full refund up until we secure your first reservation.</span>
          </p>
          <p class="c0">
            <span class="c2" />
          </p>
          <h3 class="c1">
            <span class="c2">Plan and Price Changes</span>
          </h3>
          <p class="c1">
            <span class="c3">We may change the cost of our various memberships and subscriptions at any time. These changes will apply after your current service term expires, when the next payment is due.</span>
          </p>
          <p class="c0">
            <span class="c2" />
          </p>
          <h3 class="c1">
            <span class="c2">Your Profile</span>
          </h3>
          <p class="c1">
            <span class="c3">The profile information you provide helps us represent you to our network of restaurants. It is imperative that the information within your profile accurately reflects your true identity. Impersonation or providing misleading information about your identity is strictly prohibited.</span>
          </p>
          <p class="c0">
            <span class="c2" />
          </p>
          <h3 class="c1">
            <span class="c2">Partner Restaurant SMS Messaging</span>
          </h3>
          <p class="c1">
            <span class="c3">RM sends text messages to partner restaurants that have opted in about RM members' reservation requests, upcoming bookings and other dining-related experiences at their restaurant. A restaurant's contact opts in only by affirmatively confirming the invitation RM emails to them, by replying YES to RM's text, or by asking RM's team, who record the request; consent is recorded before RM sends the first text, a welcome that repeats how to stop and how to get help. Texting is optional and declining does not affect the restaurant's relationship with RM. Messages may include the member's name and mobile number so the restaurant can reach the guest. Message frequency varies. Message and data rates may apply.</span>
          </p>
          <p class="c1">
            <span class="c3">You can cancel the SMS service at any time. Just text "STOP", we will send you an SMS message to confirm that you have been unsubscribed. After this, you will no longer receive SMS messages from us. If you want to join again, just sign up as you did the first time and we will start sending SMS messages to you again.</span>
          </p>
          <p class="c1">
            <span class="c3">If you are experiencing issues with the messaging program you can get help directly at contact@reserverm.com</span>
          </p>
          <h3 class="c1">
            <span class="c2">RM Member Text Messaging</span>
          </h3>
          <p class="c1">
            <span class="c3">Eligible RM members can use RM by text message. Texting is optional and starts only after the member affirmatively opts in: by confirming the invitation RM emails to the address on their RM account, by ticking the optional RM via text box on their membership application, by turning RM via text on in the RM app, by replying YES to RM's text from the mobile number on their RM account, or by asking RM's team, who record the request. Consent is recorded before RM sends the first text; an applicant who opts in on their application receives no text until their account is activated. After confirming, the member receives a welcome text and can text RM at +1 (312) 500-2980 at any time to use their RM membership for access, discovery, their upcoming bookings and their Dining Profile; RM replies by text. Everything a member does via text is connected to and updates their RM account.</span>
          </p>
          <p class="c1">
            <span class="c3">People applying for RM membership may text RM to apply. RM's first reply describes the program and asks for a YES; texts about the application follow only after that YES. Texts after approval are a separate choice, asked for and recorded separately. Membership requires RM's approval.</span>
          </p>
          <p class="c1">
            <span class="c3">RM via Text is part of your membership and is for you and anyone RM has approved to text for you. The Terms and the RM Member Commitment apply the same way they do in the app. If text access is used in a way that doesn't fit them, RM may pause or end it and will tell you.</span>
          </p>
          <p class="c1">
            <span class="c3">Message frequency varies with how often you text RM. Message and data rates may apply. Reply STOP to any message to opt out; reply HELP for help, or email contact@reserverm.com. Declining or ignoring the invitation does not affect your RM membership. Carriers are not liable for delayed or undelivered messages.</span>
          </p>
          <p class="c1">
            <span class="c3">As always, message and data rates may apply for any messages sent to you from us and to us from you. You will receive messages based on how often our members request reservations. If you have any questions about your text plan or data plan, it is best to contact your wireless provider.</span>
          </p>
          <p class="c1">
            <span class="c3">If you have any questions regarding privacy, please read our <a href="/privacy">privacy policy</a></span>
          </p>
          <p class="c0">
            <span class="c2" />
          </p>
          <h3 class="c1">
            <span class="c2">Warranties and Disclaimers</span>
          </h3>
          <p class="c1">
            <span class="c3">We provide RM using a reasonable level of skill and care and we hope that you will enjoy using RM. But there are certain things that we don&rsquo;t promise about RM. Other than as expressly stated, we don&rsquo;t make any commitments about the specific functionality available through RM, its reliability, completeness, quality, accuracy, implied warranties of non-infringement, availability, security, merchantability, or ability to meet your needs. IF YOU ARE DISSATISFIED WITH THE RM, YOUR SOLE REMEDY IS TO DISCONTINUE USING RM. Some jurisdictions do not allow the disclaimer of warranties, so such disclaimer may not apply to you.</span>
          </p>
          <p class="c0">
            <span class="c2" />
          </p>
          <h3 class="c1">
            <span class="c2">Liability for RM</span>
          </h3>
          <p class="c1">
            <span>RM</span><span class="c3">&nbsp;is not responsible or liable for:</span>
          </p>
          <p class="c1">
            <span class="c3">(a) losses that were not caused by our breach of these Terms;</span>
          </p>
          <p class="c1">
            <span class="c3">(b) any loss or damage that was not, at the time when the relevant contract with you was formed, a reasonably foreseeable consequence of RM breaching the Terms; or</span>
          </p>
          <p class="c1">
            <span class="c3">(c) losses relating to any business of yours including lost profits, revenues, opportunity or data.</span>
          </p>
          <p class="c1">
            <span class="c3">THE TOTAL LIABILITY OF RM FOR ANY CLAIMS UNDER THESE TERMS OR ARISING FROM OUR SERVICES, INCLUDING FOR ANY IMPLIED WARRANTIES, IS LIMITED TO THE AMOUNT YOU PAID US TO USE THE SERVICES FOR THE SIX (6) MONTH PERIOD IMMEDIATELY PRIOR TO TIME SUCH CLAIM ARISES (OR, IF THE SUBJECT OF THE CLAIM IS THE FREE SERVICE, TO SUPPLYING YOU THE SERVICES AGAIN).</span>
          </p>
          <p class="c1">
            <span class="c3">Nothing in these terms is intended to exclude or limit the liability of RM and its suppliers and distributors for death or personal injury, fraud, fraudulent misrepresentation or any liability that cannot be excluded by law. Nothing in these terms shall affect your statutory rights.</span>
          </p>
          <p class="c0">
            <span class="c2" />
          </p>
          <h3 class="c1">
            <span class="c2">About these Terms</span>
          </h3>
          <p class="c1">
            <span class="c3">At any time, we may modify these Terms or any additional terms that apply to RM, for example: to reflect changes to RM or to the law, custom, or political or economic policy; or in response to guidelines issued by regulators or relevant industry bodies; or to enable RM to meet its obligations. You should look at the Terms regularly. We&rsquo;ll post notice of modifications to these Terms on this page. Changes will not apply retroactively and will become effective no sooner than 14 days after they are posted or notified to you. However, changes addressing new functions or features (&ldquo;New Services&rdquo;) or changes made for legal reasons will be effective immediately. If you do not agree to the modified terms for a New Service, you should discontinue your use of that New Service (see &ldquo;Termination&rdquo; above, for more information).</span>
          </p>
          <p class="c1">
            <span class="c3">If there is a conflict between these Terms and the Additional Terms, the Additional Terms will control for that conflict.</span>
          </p>
          <p class="c1">
            <span class="c3">These Terms control the relationship between RM and you. They do not create any third party beneficiary rights.</span>
          </p>
          <p class="c1">
            <span class="c3">If you do not comply with these Terms, and we don&rsquo;t take action right away, this doesn&rsquo;t mean that we are giving up any rights that we may have (such as taking action in the future).</span>
          </p>
          <p class="c1">
            <span class="c3">If it turns out that a particular term is not enforceable, this will not affect any other terms.</span>
          </p>
          <p class="c0">
            <span class="c2" />
          </p>
          <h3 class="c1">
            <span class="c2">Dispute Resolution</span>
          </h3>
          <p class="c1">
            <span class="c3">The parties shall attempt to resolve any disputes through good faith business negotiations or facilitative mediation in Chicago, Illinois. Except as otherwise determined by RM, in its sole discretion, all disputes or claims arising out of or relating to these Terms shall be settled by arbitration, to be conducted by a single arbitrator in Chicago, Illinois, by and in accordance with the then effective commercial rules of the American Arbitration Association; provided that the arbitrator shall not have authority to issue injunctions. Judgment upon the award may be entered in any court having jurisdiction thereof. Other legal proceedings, if any, shall be initiated and maintained in Cook County, Illinois. The parties expressly submit to the exclusive personal jurisdiction and venue of these forums and courts and waive any objection on the grounds of personal jurisdiction, venue, or forum non conveniens.</span>
          </p>
          <p class="c0">
            <span class="c2" />
          </p>
          <h3 class="c1">
            <span class="c2">Attorneys&rsquo; Fees and Costs</span>
          </h3>
          <p class="c1">
            <span class="c3">If any litigation or other court action, arbitration, or similar adjudicatory proceeding is commenced by any party to enforce its rights under these Terms against the other party, all fees, costs and expenses, including, without limitation, cost of arbitration, reasonable attorneys&rsquo; fees and court costs, incurred by RM, if it is the prevailing party in such litigation, action, arbitration or proceeding, shall be reimbursed by you; provided, that if Reagan.com prevails in part, and loses in part, the court, arbitrator or other adjudicator presiding over such litigation, action, arbitration or proceeding shall award a reimbursement of the fees, costs and expenses incurred by Reagan.com on an equitable basis.</span>
          </p>
          <p class="c0">
            <span class="c2" />
          </p>
          <h3 class="c1">
            <span class="c2">CONTACT INFORMATION</span>
          </h3>
          <p class="c1">
            <span class="c3">If you have any questions or concerns about these Terms, please email us at contact@RM.com. You may also direct your comments or questions to the address below:</span>
          </p>
          <h3 class="c1">
            <span class="c3">RecommendMe, Inc. contact@reserverm.com</span>
          </h3>
          <p class="c0">
            <span class="c3" />
          </p>
          <p class="c1">
            <span class="c3">If you are a California resident, in accordance with Cal. Civ. Code &sect;1789.3, you may report complaints to the Complaint Assistance Unit of the Division of Consumer Services of the California Department of Consumer Affairs by contacting them in writing at 400 R Street, Sacramento, CA 95814, or by telephone at (800) 952-5210.</span>
          </p>
          <p class="c0">
            <span class="c6" />
          </p>
          <p class="c4">
            <span class="c3" />
          </p>
          <p class="c4">
            <span class="c3" />
          </p>
        </div>
      </div>
      `
    </section>


    <!--      <v-sheet class="py-16"> -->
    <!--        <section id="filter"> -->
    <!--          <v-container> -->
    <!--            <v-row justify="space-between"> -->
    <!--              <v-col cols="auto"> -->
    <!--                <v-responsive width="350"> -->
    <!--                  <h2 class="text-h4"> -->
    <!--                    Become a Member -->
    <!--                  </h2> -->

    <!--                  <p class="text-success mt-3"> -->
    <!--                    Exclusive Access -->
    <!--                  </p> -->

    <!-- &lt;!&ndash;                  <strong class="mt-3">&ndash;&gt; -->
    <!-- &lt;!&ndash;                    Version 3 Only&ndash;&gt; -->
    <!-- &lt;!&ndash;                  </strong>&ndash;&gt; -->

    <!--                  <p class="mt-8"> -->
    <!--                    For an annual fee members gain access to prime time reservations and private dining at their favorite restaurants. -->
    <!--                  </p> -->

    <!--                  <p class="mt-8"> -->
    <!--                    Our members get access to tables not available to the general public. -->
    <!--                  </p> -->

    <!--                  <v-btn -->
    <!--                    class="mt-6" -->
    <!--                    to="/members" -->
    <!--                  > -->
    <!--                    Learn More -->
    <!--                  </v-btn> -->
    <!--                  <v-btn -->
    <!--                    class="mt-6 ml-6" -->
    <!--                    to="/register" -->
    <!--                  > -->
    <!--                    JOIN NOW -->
    <!--                  </v-btn> -->
    <!--                </v-responsive> -->
    <!--              </v-col> -->

    <!--              <v-img -->
    <!--                max-width="400" -->
    <!--                :src="reservedImage" -->
    <!--              /> -->
    <!--            </v-row> -->
    <!--          </v-container> -->
    <!--        </section> -->

    <!--        <v-container> -->
    <!--          <v-divider class="my-12" /> -->
    <!--        </v-container> -->

    <!--        <section id="controls"> -->
    <!--          <v-container> -->
    <!--            <v-row justify="space-between"> -->
    <!--              <v-col cols="auto"> -->
    <!--                <v-responsive width="350"> -->
    <!--                  <h2 class="text-h4"> -->
    <!--                    Most Booked in Chicago -->
    <!--                  </h2> -->

    <!--                  <p class="text-success mt-3"> -->
    <!--                    And the list goes on... -->
    <!--                  </p> -->

    <!--                  <p class="mt-3"> -->
    <!--                    Aba, Adalina, Alla Vita, Avec, Bambola, Bazaar Meat, Chicago Cut, Duck Duck Goat, etta, Gibsons Italia, Gino & Marty's, Girl & the Goat, Le Colonial, Lyra, Maple & Ash, Momotaro, Proxi, RL Restaurant, RPMs, Steak 48, Summer House, Sunda, Sushi-San -->
    <!--                  </p> -->


    <!--                  <v-btn -->
    <!--                    class="mt-6" -->
    <!--                    to="/restaurants" -->
    <!--                  > -->
    <!--                    See All Restaurants -->
    <!--                  </v-btn> -->
    <!--                </v-responsive> -->
    <!--              </v-col> -->

    <!--              <v-img -->
    <!--                max-width="400" -->
    <!--                :src="chicagoImage" -->
    <!--              /> -->
    <!--            </v-row> -->
    <!--          </v-container> -->
    <!--        </section> -->

    <!--        <v-container> -->
    <!--          <v-divider class="my-12" /> -->
    <!--        </v-container> -->

    <!--        <section id="grid"> -->
    <!--          <v-container> -->
    <!--            <v-row justify="space-between"> -->
    <!--              <v-col cols="auto"> -->
    <!--                <v-responsive width="350"> -->
    <!--                  <h2 class="text-h4"> -->
    <!--                    Most Booked in New York -->
    <!--                  </h2> -->

    <!--                  <p class="text-success mt-3"> -->
    <!--                    And the list goes on... -->
    <!--                  </p> -->

    <!--                  <p class="mt-3"> -->
    <!--                    Aba, Adalina, Alla Vita, Avec, Bambola, Bazaar Meat, Chicago Cut, Duck Duck Goat, etta, Gibsons Italia, Gino & Marty's, Girl & the Goat, Le Colonial, Lyra, Maple & Ash, Momotaro, Proxi, RL Restaurant, RPMs, Steak 48, Summer House, Sunda, Sushi-San -->
    <!--                  </p> -->


    <!--                  <v-btn -->
    <!--                    class="mt-6" -->
    <!--                    to="/restaurants" -->
    <!--                  > -->
    <!--                    See All Restaurants -->
    <!--                  </v-btn> -->
    <!--                </v-responsive> -->
    <!--              </v-col> -->

    <!--              <v-img -->
    <!--                max-width="400" -->
    <!--                :src="nycImage" -->
    <!--              /> -->
    <!--            </v-row> -->
    <!--          </v-container> -->
    <!--        </section> -->

    <!--        <v-container> -->
    <!--          <v-divider class="my-12" /> -->
    <!--        </v-container> -->

    <!--        <section id="grid"> -->
    <!--          <v-container> -->
    <!--            <v-row justify="space-between"> -->
    <!--              <v-col cols="auto"> -->
    <!--                <v-responsive width="350"> -->
    <!--                  <h2 class="text-h4"> -->
    <!--                    Most Booked in Miami -->
    <!--                  </h2> -->

    <!--                  <p class="text-success mt-3"> -->
    <!--                    And the list goes on... -->
    <!--                  </p> -->

    <!--                  <p class="mt-3"> -->
    <!--                    Aba, Adalina, Alla Vita, Avec, Bambola, Bazaar Meat, Chicago Cut, Duck Duck Goat, etta, Gibsons Italia, Gino & Marty's, Girl & the Goat, Le Colonial, Lyra, Maple & Ash, Momotaro, Proxi, RL Restaurant, RPMs, Steak 48, Summer House, Sunda, Sushi-San -->
    <!--                  </p> -->


    <!--                  <v-btn -->
    <!--                    class="mt-6" -->
    <!--                    to="/restaurants" -->
    <!--                  > -->
    <!--                    See All Restaurants -->
    <!--                  </v-btn> -->
    <!--                </v-responsive> -->
    <!--              </v-col> -->

    <!--              <v-img -->
    <!--                max-width="400" -->
    <!--                :src="miamiImage" -->
    <!--              /> -->
    <!--            </v-row> -->
    <!--          </v-container> -->
    <!--        </section> -->
    <!--      </v-sheet> -->

    <!--      <v-sheet -->
    <!--        class="py-16" -->
    <!--        color="#787878" -->
    <!--      > -->
    <!--        <section id="grid"> -->
    <!--          <v-container> -->
    <!--            <v-row justify="space-between"> -->
    <!--              <v-col cols="auto"> -->
    <!--                <v-responsive -->
    <!--                  class="overflow-visible" -->
    <!--                  width="350" -->
    <!--                > -->
    <!--                  <h2 class="text-h4"> -->
    <!--                    RM for Restaurants -->
    <!--                  </h2> -->

    <!--                  <p class="text-success mt-3"> -->
    <!--                    Receive high quality referrals at ZERO cost. -->
    <!--                  </p> -->

    <!-- &lt;!&ndash;                  <strong>Become a sponsor</strong>&ndash;&gt; -->

    <!--                  <p class="mt-8"> -->
    <!--                    Our members want to spend good money at your restaurant and are willing to guarantee it.                  </p> -->

    <!--                  <v-btn -->
    <!--                    class="mt-6 " -->
    <!--                    to="/preferred" -->
    <!--                  > -->
    <!--                    Learn More -->
    <!--                  </v-btn> -->
    <!--                </v-responsive> -->
    <!--              </v-col> -->
    <!--            </v-row> -->
    <!--          </v-container> -->
    <!--        </section> -->
    <!--      </v-sheet> -->
    <!--    <v-footer> -->
    <!--      <v-container class="text-overline d-flex align-center justify-space-between"> -->
    <!--        <div> -->
    <!--          Copyright &copy; 2022 RecommendMe, Inc. -->
    <!--        </div> -->

    <!--        <v-icon icon="mdi-vuetify" size="x-large" /> -->
    <!--      </v-container> -->
    <!--    </v-footer> -->
  </div>
</template>

<style lang="scss">
@use "@core/scss/pages/misc.scss";

.misc-footer-tree {
  inline-size: 15.625rem;
  inset-block-end: 3.5rem;
  inset-inline-start: 0.375rem;
}
</style>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
</route>
